import * as React from 'react';

import {FormField} from 'shells/form/form-field';
import {TextField} from 'shells/textfield/textfield';
import {ModalSubheader} from 'shells/typography/modal-subheader';

type Props = {
    signingKey: string;
    setSigningKey: (signingKey: string) => void;
};

export function CallrailUpdateSigningKey(props: Props) {
    return (
        <>
            <ModalSubheader>
                A webhook integration with another provider already exists in your CallRail account.
                We’ll need the signing key from it to finish your Nutshell integration setup.
            </ModalSubheader>
            <FormField
                innerId='signingKey'
                label='Signing Key'
                noMargin={true}
                tooltipInfo='Under Integrations > Manage, select the existing Webhooks integration for your company and copy the Webhook Signature Secret Token under Advanced Settings.'
            >
                <TextField
                    value={props.signingKey}
                    onChange={(value) => props.setSigningKey(value)}
                />
            </FormField>
        </>
    );
}
